// The SEO fields on the category form belong to the category's STOREFRONT
// PAGE, not to the category row. Every category has one — created with it,
// living at its own address — and the form is where its copy is written, so
// nobody has to go and build a page separately. They are held flat (``lp_``)
// in the form and gathered into a ``landing_page`` object on save.
export const LANDING_PAGE_FIELDS = [
  "seo_title", "ar_seo_title",
  "meta_description", "ar_meta_description",
  "h1", "ar_h1",
  "intro_html", "ar_intro_html",
];

/** The form's ``lp_`` values for a page; blank, and on Google, when there is none yet. */
export const landingPageValues = (page) =>
  LANDING_PAGE_FIELDS.reduce(
    (acc, field) => ({ ...acc, [`lp_${field}`]: page?.[field] || "" }),
    { lp_is_indexable: page?.is_indexable ?? true },
  );

/**
 * Split the form back into its two halves: the category row, and the copy for
 * its storefront page. Sending the page fields flat would write them to the
 * category, where nothing reads them. Every copy field is sent, empty ones as
 * "", so clearing a box clears it on the page.
 */
export const splitLandingPageValues = (values) => {
  const category = Object.fromEntries(
    Object.entries(values).filter(([key]) => !key.startsWith("lp_")),
  );
  category.landing_page = LANDING_PAGE_FIELDS.reduce(
    (acc, field) => ({ ...acc, [field]: values[`lp_${field}`] ?? "" }),
    { is_indexable: Boolean(values.lp_is_indexable) },
  );
  return category;
};
